import {
  GET_DASHBOARD_FINISH_TASKS,
  GET_DASHBOARD_FINISH_TASKS_SUCCESS,
  GET_DASHBOARD_FINISH_TASKS_ERROR,
} from './actionTypes';

// P01021-139: tarjeta "Finalizadas" del Dashboard — paginada y filtrada por servidor,
// en vez de traer toda tasklist. Antes de este fix, getAllTasksPaginated devolvía
// siempre 0 resultados para este estado (floor incondicional >= Pendiente de retorno).
export const getDashboardFinishTasks = (user, size, page) => {
  return {
    type: GET_DASHBOARD_FINISH_TASKS,
    payload: { user, size, page },
  };
};

export const getDashboardFinishTasksSuccess = (tasks, message) => {
  return {
    type: GET_DASHBOARD_FINISH_TASKS_SUCCESS,
    payload: { tasks, message },
  };
};

export const getDashboardFinishTasksError = (msg) => {
  return {
    type: GET_DASHBOARD_FINISH_TASKS_ERROR,
    payload: msg,
  };
};
